import { Navigate } from 'react-router-dom';

function toClaims(profile) {
  if (!profile) return [];
  if (Array.isArray(profile.claims)) return profile.claims;
  return Object.entries(profile).flatMap(([type, value]) =>
    Array.isArray(value) ? value.map(v => ({ type, value: String(v) })) : [{ type, value: String(value) }]);
}

export function ClaimGuardRoute({ user, requiredClaim, element, loading }) {
  if (!requiredClaim) return element;
  if (loading) return null; // wait for user to load to avoid false negatives
  const claims = toClaims(user);
  const hasClaim = claims.some(c => c.type === requiredClaim.type && c.value === requiredClaim.value);
  return hasClaim ? element : <Navigate to="/not-authorized" />;
}
